import { Box, Theme, Typography } from "@outschool/backpack";
import { Trans, useTranslation } from "@outschool/localization";
import { joinMembershipPath } from "@outschool/routes";
import { useTrackEvent } from "@outschool/ui-analytics";
import { useIsMobile, useNavigation } from "@outschool/ui-utils";
import React, { useEffect } from "react";

export default function FirstMonthFreeBanner() {
  const { t } = useTranslation(
    "client\\components\\banners\\FirstMonthFreeBanner",
  );
  const navigate = useNavigation();
  const trackEvent = useTrackEvent();
  const isMobile = useIsMobile();

  // Track if banner view has been tracked for this mount to prevent duplicate tracking
  const hasTrackedViewRef = React.useRef<boolean>(false);

  useEffect(() => {
    if (!hasTrackedViewRef.current) {
      hasTrackedViewRef.current = true;
      trackEvent("first_month_free_banner_view", {
        is_mobile: isMobile,
      });
    }
  }, [trackEvent, isMobile]);

  const handleBannerClick = () => {
    trackEvent("first_month_free_banner_click", {
      is_mobile: isMobile,
    });
    navigate(joinMembershipPath());
  };

  return (
    <Box
      sx={(theme: Theme) => ({
        display: "flex",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary[600],
        minHeight: "50px",
        cursor: "pointer",
        padding: "0 1em",
        [theme.breakpoints.down("md")]: {
          padding: "20px",
        },
      })}
      onClick={handleBannerClick}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "1440px",
          margin: "0 auto",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flex: 1,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Typography variant="body1" sx={{ textAlign: "center" }}>
              <Trans t={t}>
                <b>First Month Free</b> — use code BTS40. Offer valid for 80
                credits plan.
              </Trans>
              <Box
                component="span"
                sx={{
                  marginLeft: 8,
                  textDecoration: "underline",
                }}
              >
                {t("Learn More")}
              </Box>
            </Typography>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
